import { BasketModifierSelection } from "../../../store/slices/basketSlice";
import { isRemovalGroupName } from "../../home/libs/modifiers";

/** У части позиций знак уже в названии («+ Сыр», «- Лук») — второй не нужен. */
const stripSign = (name: string) => name.replace(/^\s*[+\-−–]\s*/, "").trim();

/**
 * Состав под названием блюда в корзине — не больше двух строк: в первой всё
 * добавленное через запятую с одним «+», во второй — убранное с одним «−»:
 * «+ Мясо, Сыр» / «− Лук, Помидоры».
 *
 * Знак уже говорит, что ингредиент убран, поэтому «без …» к названию не
 * подставляем: у части блюд позиции и так приходят как «Без лука», и шаблон
 * давал «без Без лука».
 */
export const formatModifierLines = (modifiers: BasketModifierSelection[]) => {
  const added: string[] = [];
  const removed: string[] = [];

  modifiers.forEach(modifier => {
    const name = stripSign(modifier.itemName);

    if (isRemovalGroupName(modifier.groupName)) {
      removed.push(name);
      return;
    }

    added.push(`${name}${modifier.quantity > 1 ? ` ×${modifier.quantity}` : ""}`);
  });

  return [
    added.length ? `+ ${added.join(", ")}` : null,
    removed.length ? `− ${removed.join(", ")}` : null,
  ].filter((line): line is string => line !== null);
};
